// TODO: remove this temp logic when this is finished on svc-tour
const mockedTourOperators = {
  'tour-5a700484-a93b-44f7-973f-f24ec97d1a7e': { tourOperator: 'Tomato Travel', tourOperatorCountry: 'South Korea' },
  'tour-4297447c-90ee-444b-9188-984ff96467d4': { tourOperator: 'Tomato Travel', tourOperatorCountry: 'South Korea' },
  'tour-2ba38e1d-b276-4a9a-8898-8d957e2cb9b0': { tourOperator: 'Park Trek Walking Holidays', tourOperatorCountry: 'Australia' },
  'tour-bb3a642f-8cb8-4a36-af0a-28b3629f618d': { tourOperator: 'Park Trek Walking Holidays', tourOperatorCountry: 'Australia' },
  'tour-fee90207-0637-44f9-a023-7cb7b4dc205f': { tourOperator: 'Park Trek Walking Holidays', tourOperatorCountry: 'Australia' },
  'tour-972dca16-68a2-4bda-b0a1-76dd58d2ad49': { tourOperator: 'Park Trek Walking Holidays', tourOperatorCountry: 'Australia' },
  'tour-5d2599a2-c074-49df-9e84-3b5ac105a471': { tourOperator: 'Meet and Greet SRL', tourOperatorCountry: 'Italy' },
  'tour-6b54b28e-246f-4a04-ac3e-3c8f435ba05a': { tourOperator: 'Meet and Greet SRL', tourOperatorCountry: 'Italy' },
  'tour-fae5c398-4dff-41f4-b1a7-557347be25e6': { tourOperator: 'Meet and Greet SRL', tourOperatorCountry: 'Italy' },
  'tour-ff0cad2e-1d45-45b4-9700-fc913046a3aa': { tourOperator: 'Meet and Greet SRL', tourOperatorCountry: 'Italy' },
  'tour-cf0d8f66-0dcc-4af1-98c3-435022f0d9b8': { tourOperator: 'Halong Tours Booking', tourOperatorCountry: 'Vietnam' },
  'tour-ea0a7404-0245-40cc-865c-38805bdd588a': { tourOperator: 'Ciconia Exclusive Journeys', tourOperatorCountry: 'Turkey' },
  'tour-48ff130f-b5f7-44e3-8d66-538df0fef35f': { tourOperator: 'Australian Luxury Escapes', tourOperatorCountry: 'Australia' },
  'tour-b4914dac-d8fe-450d-8290-023733fa4bc8': { tourOperator: 'Tour Operator Test', tourOperatorCountry: 'Australia' }, // From test environment
}

export function getTourOperatorCountry(tourId: string) {
  const tourInfo = mockedTourOperators[tourId]

  return tourInfo?.tourOperatorCountry
}
